<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="患者姓名:"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                v-model="patName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="身份证号:"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                :allowClear="true"
                v-model="idCard"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 lianxi">
            <a-form-item
              label="联系方式:"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                :allowClear="true"
                v-model="phoneNo"
              />
            </a-form-item>
          </a-col>

          <a-col :span="6" class="oper">
            <div style="height: 41px; line-height: 41px; margin-left: -18px">
              <a-button class="btone" @click="searchList(1)">查询</a-button>
              <a-button class="btthree" @click="showReturn"
                >返回上级菜单</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :data-source="tableData"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
        class="table"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + (pageNum - 1) * pageSize + 1 }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{ record.status | DictionaryFilter("DICT_STATUS") }}
        </span>
        <span slot="relation" slot-scope="text, record">
          {{ record.relation | DictionaryFilter("KINSHIP") }}
        </span>
        <!-- 操作 -->
        <template slot="operation" slot-scope="text">
          <a-button
            href="javascript:;"
            class="btaction"
            @click="configuration(text)"
            >详情</a-button
          >
        </template>
      </a-table>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
      <!-- 详情 -->
      <addModal
      v-if="visible"
      :visible="visible"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      :textId="textId"
    ></addModal>
    </div>
  </div>
</template>
<script>
import { patQuery, pagedictAdd, diagQuery, medQuery } from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
import addModal from "./manage-details-add.vue";
moment.locale("zh-cn");
export default {
  components: {
    addModal: addModal,
  },
  data() {
    return {
      //详情弹窗
      visible: false,
      userData: [],
      idCard: "",
      patName: "",
      phoneNo: "",
      //表格
      tableData: [],
      //表格1
      tableData1: [],
      //表格2
      tableData2: [],
      Title: "",
      title:"",
      //数列
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 50,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "患者姓名",
          dataIndex: "patName",
          key: "patName",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "patName" },
        },
        {
          title: "身份证号",
          dataIndex: "idCard",
          key: "idCard",
          align: "center",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "idCard" },
        },
        {
          title: "联系方式",
          dataIndex: "phoneNo",
          key: "phoneNo",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "phoneNo" },
        },
        {
          title: "与患者关系",
          dataIndex: "relation",
          key: "relation",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "relation" },
        },
        {
          title: "年龄",
          dataIndex: "age",
          key: "age",
          align: "center",
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: "age" },
        },

        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "createTime" },
        },

        {
          title: "籍贯",
          dataIndex: "placeOrigin",
          key: "placeOrigin",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "placeOrigin" },
        },
        {
          title: "修改时间",
          dataIndex: "updateTime",
          key: "updateTime",
          align: "center",
          width: 150,
          scopedSlots: { customRender: "updateTime" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 150,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],

      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,

      formLayout: "horizontal",
      textId:"",
      relationMan:[]
    };
  },
  watch: {},
  activated() {
    DictionaryService.getAllNeedDic(["DICT_STATUS","KINSHIP"]).then((res) => {
      this.searchList();
      this.dictStatus = DictionaryService.getOptions("DICT_STATUS");
      this.relationMan = DictionaryService.getOptions("KINSHIP");
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    // 详情
    configuration(text) {
      this.id = text.id;
      this.visible = true;
      this.type = "add";
      this.title = "详情";
      this.textId = text.id
    },
    // 关闭弹窗
    reflush(value) {
      this.visible = false;
    },
    //返回
    showReturn() {
      this.$router.push({
        path: "/home/customer/register/manage",
      });
    },
    //分页
    changePageFn(event) {
      this.pageNum = event;
      this.searchList();
    },
    //列表查询
    searchList(sum = 2) {
      this.custId = this.$route.query.id;

      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          custId: this.custId,
          idCard: this.idCard,
          patName: this.patName,
          phoneNo: this.phoneNo,
        },
      };
      patQuery(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 20px;
  }
  .btthree {
    width: 120px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
.name {
  font-size: 14px;
  display: inline-block;
  text-align: center;
  width: 26%;
}
.frame {
  width: 74%;
  display: inline-block;
}

.add-mess {
  width: 100%;
  //height: 400px;
  overflow: auto;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 110px;
  }
  /deep/ .ant-form-item-control {
    width: 350px;
  }
}
::v-deep .ant-table-small.ant-table-bordered .ant-table-placeholder {
  display: none;
}

/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 246px;
}
.lianxi {
  margin-left: -4px;
  width: 260px;
}
.oper {
  // flex: 1;
  width: 310px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 74px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 69px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 69px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 50%;
}
</style>